export function slugify(s) {
  return String(s ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "table";
}

function csvEscape(v) {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

export function sarSpecToCsv(spec) {
  const rGroupKeys = Array.isArray(spec.r_groups) ? spec.r_groups : [];
  const columns = Array.isArray(spec.columns) ? spec.columns : [];

  const headers = [
    "id",
    "label",
    "mol_smiles",
    ...rGroupKeys.map((k) => `${k}_smiles`),
    ...columns.map((c) => c.key),
    "source_id",
  ];

  const lines = [headers.map(csvEscape).join(",")];

  for (const row of spec.rows || []) {
    const molSmiles = row.molecule?.smiles ?? "";
    const rGroupCells = rGroupKeys.map((k) => row.r_groups?.[k]?.smiles ?? "");
    const dataCells = columns.map((c) => row.data?.[c.key] ?? "");
    const cells = [
      row.id ?? "",
      row.label ?? "",
      molSmiles,
      ...rGroupCells,
      ...dataCells,
      row.source_id ?? "",
    ];
    lines.push(cells.map(csvEscape).join(","));
  }

  return {
    csv: lines.join("\n"),
    filename: `${slugify(spec.title || "sar-table")}.csv`,
  };
}
